<template>
  <div v-if="tasks.length">
    <div v-for="task in tasks" :key="task.id">
      <v-fade-transition mode="out-in">
        <task-checkbox :task="task" v-show="showCompleted || !task.completed">
          <template #title>
            <router-link :to="{ name: 'task', params: { task_id: task.id } }">{{
              task.title
            }}</router-link>
          </template>
        </task-checkbox>
      </v-fade-transition>
    </div>
  </div>

  <div v-else class="pt-4">
    No tasks found.
  </div>
</template>

<script>
import TaskCheckbox from '../common/TaskCheckbox'

export default {
  name: 'ProjectTasks',
  props: {
    tasks: {
      type: Array,
      required: true
    },
    showCompleted: {
      type: Boolean,
      required: true
    }
  },
  components: {
    TaskCheckbox
  }
}
</script>
